/**
 * @desc 分页
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.PurchaseOrderSrmRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/purchaseOrder/pageList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
